import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,{attrs:{"justify":"center"}},[_c(VCol,{attrs:{"md":"5"}},[_c(VAlert,{attrs:{"type":"info","outlined":"","prominent":""}},[_vm._v("Votre liste est vide, "),_c(VBtn,{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("cliquez-ici")]),_vm._v(" pour la remplir.")],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }